import slice from "./termsOfUseSlice";

export default slice.reducer;
